var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"white--text",attrs:{"color":"primary","elevation":"5"}},[_c('span',{staticClass:"text-center text-sm-left"},[_vm._v(_vm._s(_vm.$t('no_files_uploaded')))])])}
var staticRenderFns = []

export { render, staticRenderFns }